import React from "react";
import { motion } from "framer-motion";
import { WORKFLOWS } from "../lib/content";
import { ChevronDown } from "lucide-react";

export default function WorkflowsGrid({ filterIds }) {
  const items = filterIds
    ? filterIds.map((id) => WORKFLOWS.find((w) => w.id === id)).filter(Boolean)
    : WORKFLOWS;

  return (
    <section
      id="workflows"
      data-testid="workflows-section"
      className="bg-[#FAF7F2] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <p className="kicker">Five workflows</p>
            <h2 className="h-section text-[clamp(2rem,4vw,3.4rem)] mt-5 max-w-3xl">
              Five workflows. Each one pays for itself.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-serif-body text-[#4A4A4A] text-[1.05rem] leading-relaxed">
              Hover or tap any card to see the kind of draft Atlas will write
              for you. Real copy. Same tone you'd use yourself.
            </p>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((w, i) => (
            <WorkflowCard key={w.id} w={w} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function WorkflowCard({ w, idx }) {
  const Icon = w.icon;
  const [open, setOpen] = React.useState(false);

  return (
    <motion.article
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.45, delay: idx * 0.04 }}
      className={`workflow-card p-7 ${open ? "is-open" : ""}`}
      data-testid={`workflow-card-${w.id}`}
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-sm bg-[#0B3D5C] text-[#FAF7F2] flex items-center justify-center">
          <Icon size={18} />
        </div>
        <div className="flex-1">
          <h3 className="h-card text-[1.2rem]">{w.title}</h3>
          <p className="font-serif-body text-[#4A4A4A] mt-2 text-[15px] leading-relaxed">
            {w.summary}
          </p>
        </div>
      </div>

      <div className="reveal mt-5">
        <div className="border-t border-[#E5E0D8] pt-4">
          <p className="font-mono-spec text-[11px] text-[#4A4A4A]">
            Sample draft Atlas writes
          </p>
          <p className="font-sans-tight text-[13px] font-semibold text-[#0B3D5C] mt-2">
            {w.sample.subject}
          </p>
          <p className="font-serif-body text-[14px] text-[#1A1A1A] mt-2 leading-relaxed">
            {w.sample.body}
          </p>
        </div>
      </div>

      <button
        className="md:hidden mt-4 inline-flex items-center gap-2 font-sans-tight text-[13px] text-[#0B3D5C]"
        onClick={() => setOpen((v) => !v)}
        data-testid={`workflow-toggle-${w.id}`}
      >
        {open ? "Hide draft" : "See the draft"}
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
    </motion.article>
  );
}
